import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import ReparacionGuardas from "./pages/ReparacionGuardas";
import FabricacionGuardas from "./pages/FabricacionGuardas";
import AdminLogin from "./pages/AdminLogin";
import AdminContacts from "./pages/AdminContacts";
import AdminRepairQuotes from "./pages/AdminRepairQuotes";
import AvisoDePrivacidad from "./pages/AvisoDePrivacidad";
import { AdminAuthProvider } from "./context/AdminAuthContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <AdminAuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/reparacion-de-guardas-telescopicas-cnc" element={<ReparacionGuardas />} />
            <Route path="/fabricacion-de-guardas-telescopicas-cnc" element={<FabricacionGuardas />} />
            <Route path="/aviso-de-privacidad" element={<AvisoDePrivacidad />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/contactos" element={<AdminContacts />} />
            <Route path="/admin/reparaciones" element={<AdminRepairQuotes />} />
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
